<template>
	<div class="cart-list-wrapper" v-bind:style="{'bottom': heigth + 'px'}">
		<div class="list" v-for="(item, index) in cartList" :key="index">
			<div class="list-checkbox">
				<input type="checkbox" class='checkbox' :id='index' v-model="item.checked" @change="changeSingleStatu(item.checked, index)" :disabled="have_gift>0" v-if="!isCheckedAll">
				<input type="checkbox" class='checkbox' :id='index' v-model="item.checked" @change="changeSingleStatu(item.checked, index)" v-if="isCheckedAll">
				<label :for="index"></label>
			</div>
			<div class="list-item" @click="goDetail(item.product.id)">
				<div class="item">
					<div class="ui-image">
						<img :src="getPhotoUrl(item)" v-if='!isPhotoEmpty(item)'>
						<img src="../../../assets/image/change-icon/default_image_02@2x.png" v-if='isPhotoEmpty(item)'>
						<span v-if="item.product.good_stock == 0" class='stock-info'>已售罄</span>
						<span v-if="item.product.good_stock > 0 && item.product.good_stock <= 10" class='stock-info'>仅剩{{ item.product.good_stock }}件</span>
						<span class="promos" v-if="item.product.activity && item.product.activity.display_time">促销</span>
					</div>
					<div class="list-info">
            <div class="product-header">
              <img class="promos-icon" v-if="item.product.promos && item.product.promos.length > 0" src="../../../assets/image/change-icon/c0_sale@2x.png" />
              <h3 class="product-title" v-bind:class="{'disabled-list': item.product.good_stock == 0}">{{item.product.name}}</h3>
            </div>
            <h3 style="font-size: 12px;color: #FA800A;margin-left:6px;" v-if="item.product.promos && item.product.promos.length > 0">{{ getPromosString(item) }}</h3>
						<h3 class="property-info">{{ item.property}}</h3>
						<div class="info-price">
							<p v-bind:class="{'disabled-list': item.product.good_stock == 0}">￥{{  item.is_gift !='0'?item.gift_price:item.product.current_price }}</p>
							<div class="ui-number">
								<div class="reduce ui-common" @click.stop="item.is_gift==0?reduceNumber(item.id, item.amount, index):''" 
                      v-bind:class="{'reduce-opacity': item.is_gift>0 || item.amount <= 1}">-</div>
                    <input type="number" min="1" class="number" value="1" v-model="item.amount" readonly="true">
                <div class="add ui-common"  v-bind:class="{'reduce-opacity': item.is_gift>0}" 
                      @click.stop="item.is_gift=='0'?addNumber(item.id, item.amount, item.product.good_stock, index):''">+</div>
							</div>
						</div>
					</div>
				</div>
				<p class="list-promotion-info" v-if='item.product.promos && item.product.promos.length > 0' v-for="(key, value) in item.product.promos" :key="value"><span>{{key.name}}</span>{{key.promo}}</p>
			</div>
		</div>
    <div v-for="(item, index) in packageGood" :key="index">
      <div class="order-header">
        <div class="order-header-item" id="order-item-left">
          <img class="order-header-icon" src="../../../assets/image/change-icon/b0_activty@2x.png" />
          <label class="item-title order-header-title">{{item.goods_name}}</label>
        </div>
      </div>
      <div class="list"v-for="(good, i) in item.goods_list" :key="i">
        <div class="list-item" style="width:80%" @click="goDetail(good.goods_id)">
          <div class="item" style="padding-left:20%;">
            <div class="ui-image">
              <img :src="good.goods_thumb" v-if='good.goods_thumb'>
            </div>
            <div class="list-info">
              <div class="product-header">
                <h3 class="product-title" v-bind:class="{'disabled-list': good.goods_name}">{{good.goods_name}}</h3>
              </div>
              <div class="info-price">
                <p v-bind:class="{'disabled-list': good.rank_price == 0}">￥{{ good.rank_price }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="order-header">
        <div class="list">
          <div class="list-checkbox">
            <input type="checkbox" class='checkbox' :id="'g'+index" v-model="item.checked" @change="changePackageGoodSingleStatu(item.checked, 'g'+index)" :disabled="have_gift>0"  v-if="!isCheckedAll">
            <input type="checkbox" class='checkbox' :id="'g'+index" v-model="item.checked" @change="changePackageGoodSingleStatu(item.checked, 'g'+index)" v-if="isCheckedAll">
            <label :for="'g'+index"></label>
          </div>
        </div>
        <div class="order-header-item" id="order-item-left">
          <label  style="font-size: 17px;color: #FA800A;padding-left:20px;margin: 0px;display: inline-block;" class="item-title order-header-title">组合价:￥{{item.goods_price}}</label>
        </div>
        <div class="list">
          <div class="list-item">
            <div class="item">
              <div class="list-info">
                <div class="info-price">
                  <div class="ui-number">
                    <div class="reduce ui-common" @click.stop="reducePackageGoodNumber(item.rec_id, item.goods_number, index)" 
                        v-bind:class="{'reduce-opacity':  item.goods_number <= 1}">-</div>
                      <input type="number" min="1" class="number" value="1" 
                        v-model="item.goods_number" readonly="true">
                    <div class="add ui-common" 
                        @click.stop="addPackageGoodNumber(item.rec_id, item.goods_number, item, index)">+</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { Indicator , Toast } from 'mint-ui';
import { orderPrice } from '../../../api/order';
import {
  cartGet,
  cartDelete,
  cartUpdate,
  cartQuantity
} from '../../../api/cart';
import { productValidate } from '../../../api/product';

export default {
  props: {
    isCheckedAll: {
      type: Boolean,
      default: false
    },
    heigth: {
      type: Number,
      default: 44
    }
  },  
  data() {
    return {
      have_gift:0,//是否有换购
      cartList: [], //购物车列表
      packageGood:[],//组合促销列表
      indicator: { spinnerType: 'fading-circle' },
      orderprice: [], // 购物车总价
      cartGoods: [], // 购物车中选中的商品
      total_amount: 0, //购物车数量
      promosIds: [] //促销信息IDS
    };
  },
  created() {
    this.getCartList(true);
  }, 
  methods: {
    ...mapMutations({
      getAmount: 'calculationAmount',
      getPrice: 'calculationPrice',
      setCartNumber: 'setCartNumber',
      saveSelectedCartGoods: 'saveSelectedCartGoods'
    }),
    isPhotoEmpty(item) {
      let url = this.getPhotoUrl(item)
      return url && url.length ? false : true
    },
    getPromosString(item){
      let string = ''
      item.product.promos.forEach(element => {
        string += (element.promo +";")
      });
      return string
    },
    getPhotoUrl(item) {
      let default_photo = item.product.default_photo
      if (default_photo) {
        if (default_photo.large) {
          return default_photo.large
        } else if (default_photo.thumb) {
          return default_photo.thumb
        }
      }
      return null
    },
    /*
		 * getCartList: 获取购物车列表
		 */
    getCartList(value) {
      cartGet().then(res => {
        if (res && res.goods_groups.length > 0) {
          this.have_gift = res.goods_groups[0].have_gift
          this.cartList = Object.assign([], res.goods_groups[0].goods);
          this.packageGood =  Object.assign([], res.goods_groups[0].package_goods);
          this.addChecked(value);
          this.renderCart();
        } else {
          this.cartList = [];
          this.packageGood = [];
        }
        this.$parent.$emit('list-is-empty', {cartList: this.cartList, packageGood: this.packageGood});
      });
    },

    /*
		 * addChecked: 为每个商品添加checked 属性
		 * @param: isSelectedall 是否选中商品 Boolean
		 */
    addChecked(isSelectedall) {
      let list = this.cartList;
      for (let i = 0, len = list.length - 1; i <= len; i++) {
        if (list[i].product.good_stock == 0 && !this.isCheckedAll) {
          list[i].checked = false;
        } else {
          list[i].checked = isSelectedall;
        }
      }
      this.cartList = Object.assign([], list);

      let plist = this.packageGood;
      for (let i = 0, len = plist.length - 1; i <= len; i++) {
        if (!this.isCheckedAll) {
          plist[i].checked = isSelectedall;
        } else {
          plist[i].checked = false;
        }
      }
      this.packageGood = Object.assign([], plist);
      
    },



    updatePackageGoodList(index) {
      cartGet().then(res => {
        if (res && res.goods_groups.length > 0) {
          Indicator.close();
          let data = res.goods_groups[0].package_goods;
          this.packageGood[index].goods_number = data[index].goods_number;
          this.renderCart();
        }
      });
    },


    /*
		 *  updateList: 加减之后更新列表
		 */
    updateList(index) {
      this.getCartList(true);
      cartGet().then(res => {
        if (res && res.goods_groups.length > 0) {
          Indicator.close();
          let data = res.goods_groups[0].goods;
          this.cartList[index].amount = data[index].amount;
          this.renderCart();
        }
      });
    },

    /*
		 *  renderCart: 修改商品数量和点击是否选中后 重新计算商品价格和数量
		 */
    renderCart() {
      let data = this.cartList;
      this.total_amount = 0;
      this.orderprice = [];
      this.cartGoods = [];
      this.promosIds = [];
      for (let i = 0, len = data.length; i <= len - 1; i++) {
        if (data[i].checked) {
          let obj = {
            goods_id: data[i].product.id,
            property: [],
            num: data[i].amount,
            is_gift:data[i].is_gift || '0'
          };
          if (data[i].attrs) {
            if (typeof data[i].attrs !== 'number') {
              let attrs = data[i].attrs.split(',');
              for (let i = 0; i <= attrs.length - 1; i++) {
                obj.property.push(attrs[i]);
              }
            } else {
              obj.property.push(data[i].attrs.toString());
            }
          }
          this.orderprice.push(obj);
          this.promosIds.push(data[i].id);
          this.total_amount =  Number(this.total_amount) + Number(data[i].amount);
          this.cartGoods.push(data[i]);
        }
      }

      let package_data = this.packageGood;
      for (let i = 0, len = package_data.length; i <= len - 1; i++) {
        if (package_data[i].checked) {
          let obj = {
            goods_id: package_data[i].goods_id,
            property: [],
            num: package_data[i].goods_number,
            is_gift:'0'
          };
          this.orderprice.push(obj);
          this.total_amount =  Number(this.total_amount) + Number(package_data[i].goods_number);
          this.cartGoods.push(package_data[i]);
        }
      }
      this.getOrderPrice();
    },

    /*
		 *  getOrderPrice 获取购物车价格
		 */
    getOrderPrice() {
      let params = {
        shop: null,
        order_product: [],
        consignee: null,
        shipping: null,
        coupon: null,
        cashgift: null,
        score: null,
        is_gift: 0,
        package_product:[]
      };
      
      if (this.orderprice.length == 0 & this.packageGood.length == 0) {
          this.getAmount(0);
          this.getPrice(0.0);
          return;
      } else {
        params.order_product = JSON.stringify(this.orderprice || []);
        var package_product = []
        if(this.packageGood.length>0){
           this.packageGood.forEach((item)=>{
             if(item.checked){
               package_product.push({goods_id:item.goods_id,num:item.goods_number})
             }
           })
        }
        params.package_product = JSON.stringify(package_product);
      }
      orderPrice(
        params.shop,
        params.order_product,
        params.consignee,
        params.shipping,
        params.coupon,
        params.cashgift,
        params.score,
        params.is_exchange,
        params.package_product
      ).then(res => {
        if (res) {
          let price = res.order_price.total_price;
          this.getAmount(this.total_amount);
          this.getPrice(price);
        }
      });
    },

    /*
		 * deleteSelected: 删除购物车数据
		 */
    deleteSelected() {
      let data = this.cartList,
         pData = this.packageGood,
        deleteGoods = [];
      this.promosIds = [];
      for (let i = 0, len = data.length; i <= len - 1; i++) {
        if (data[i].checked) {
          deleteGoods.push(data[i].id);
          this.promosIds.push(data[i].id);
        }
      }

      for (let i = 0, len = pData.length; i <= len - 1; i++) {
        if (pData[i].checked) {
          deleteGoods.push(pData[i].rec_id);
        }
      }

      if (deleteGoods.length > 0) {
        deleteGoods = JSON.stringify(deleteGoods);
      } else {
        Toast('当前没有可删除的商品');
        return;
      }
       Indicator.open();
      cartDelete(deleteGoods).then(res => {
        if (res) {
          this.getCartNumber();
          this.getCartList(false);
          Indicator.close();
        }
      });
    },

    /*
		 *  changeSingleStatu: 改变单个商品是否选中的状态, 然后重新获取商品的件数和价格
		 *  @param ： state 选中的状态
		 *  @param: index 当前改变的商品的index
		 */
    changeSingleStatu(state, index) {
      let data = this.cartList,
        length = 0,
        status = false;
      for (let i = 0, len = data.length - 1; i <= len; i++) {
        if (data[i].checked) {
          length = length + 1;
        }
      }
      if (length == data.length) {
        status = true;
      } else {
        status = false;
      }
      this.$parent.$emit('change-footer-status', status);
      if (!this.isCheckedAll) {
        this.renderCart();
      }
    },

    changePackageGoodSingleStatu(state, index) {
      let data = this.packageGood,
        length = 0,
        status = false;
      for (let i = 0, len = data.length - 1; i <= len; i++) {
        if (data[i].checked) {
          length = length + 1;
        }
      }
      if (length == data.length) {
        status = true;
      } else {
        status = false;
      }
      this.$parent.$emit('change-footer-status', status);
      if (!this.isCheckedAll) {
        this.renderCart();
      }
    },
    

    /*
		 *  reduceNumber: 数量减少
		 *  @param: id 当前减少的商品id
		 *  @param: amount 数量
		 *  @param： index 当前减少的index
		 */
    reduceNumber(id, amount, index) {
      if (amount > 1) {
        amount--;
        this.updateCartQuantity(id, amount, index);
      } else {
        Toast({
          message: '受不了了， 宝贝不能再少了'
        });
      }
    },


    reducePackageGoodNumber(id, amount, index) {
      if (amount > 1) {
        amount--;
        this.updatePackageGoodQuantity(id, amount, index);
      } else {
        Toast({
          message: '受不了了， 宝贝不能再少了'
        });
      }
    },
    

    addPackageGoodNumber(id, amount, stock, index) {
      if (amount <= stock) {
        amount++;
        this.updatePackageGoodQuantity(id, amount, index);
      } else {
        Toast({
          message: '该商品总库存不足'
        });
      }
    },

    /*
		 *  addNumber: 数量增加
		 *  @param: id 当前减少的商品id
		 *  @param: amount 数量
		 *  @param: stock 库存
		 *  @param： index 当前减少的index
		 */
    addNumber(id, amount, stock, index) {
      if (Number(amount) <= Number(stock) ) {
        amount++;
        this.updateCartQuantity(id, amount, index);
      } else {
        Toast({
          message: '该商品总库存不足'
        });
      }
    },


    updatePackageGoodQuantity(id, amount, index) {
      cartUpdate(id, amount).then(
        res =>
         {
          if (res) {
            Indicator.open(this.indicator);
            this.updatePackageGoodList(index);
            this.getCartNumber();
          }
        },
        error => {
          Toast('请求异常:'+error.errorMsg);
        }
      );
    },
    /*
		 * updateCartQuantity: 商品数量加减更新数
		 * @param: id 当前减少的商品id
		 * @param: amount 数量
		 * @param： index 当前操作的商品的index
		 */
    updateCartQuantity(id, amount, index) {
      cartUpdate(id, amount).then(
        res =>
         {
          if (res) {
            Indicator.open(this.indicator);
            this.updateList(index);
            this.getCartNumber();
          }
        },
        error => {
          Toast('请求异常:'+error.errorMsg);
        }
      );
    },
    /*
		 * getCartNumber： 获取购物车列表
		 */
    getCartNumber() {
      cartQuantity().then(res => {
        if (res) {
          this.setCartNumber(res.quantity);
        }
      });
    },

    goRepurchase(){
      this.$router.push({ name: 'repurchase'});
    },

    /*
		 *  goDetail: 跳转到详情
		 */
    goDetail(id) {
      this.$router.push({ name: 'product', query: { id: id } });
    },

    /*
		 *productValidate: 结算时判断
		 */
    productValidate() {
      this.saveSelectedCartGoods({ cartGoods: this.cartGoods });
      this.$router.push({ name: 'checkout', params: {isExchange: 0, exchangeScore: 0, isCart: true} });

      // TODO: 去除结算校验
      // let data = this.cartList;
      // let validate = [];
      // for (let i = 0; i <= data.length - 1; i++) {
      //   let obj = {
      //     product_id: data[i].product.id,
      //     property: [],
      //     product_number: data[i].amount
      //   };
      //   if (data[i].attrs) {
      //     if (typeof data[i].attrs !== 'number') {
      //       let attrs = data[i].attrs.split(',');
      //       for (let i = 0; i <= attrs.length - 1; i++) {
      //         obj.property.push(attrs[i]);
      //       }
      //     } else {
      //       obj.property.push(data[i].attrs.toString());
      //     }
      //     // obj.property = toString(data[i].attrs).split(',');
      //   }
      //   if (data[i].checked) {
      //     validate.push(obj);
      //   }
      // }
      // if (validate.length > 0) {
      //   productValidate(JSON.stringify(validate)).then(
      //     res => {
      //       if (res) {
      //         if (res.is_valid) {
      //           this.saveSelectedCartGoods({ cartGoods: this.cartGoods });
      //           this.$router.push({ name: 'checkout' });
      //         }
      //       }
      //     },
      //     error => {
      //       Toast('请求异常:'+error.errorMsg);
      //     }
      //   );
      // }
    }
  }
};
</script>

<style lang='scss' scoped>
.cart-list-wrapper {
  overflow-y: auto;
  position: fixed;
  width: 100%;
  bottom: 44px;
  top: 80px;
  margin-top: 8px;
  margin-bottom: 10px;
  .order-header {
		height: 44px;
		position: relative;
		display: flex;
		flex-direction: row;
		justify-content: space-around;
		align-content: stretch;
		background-color: #fff;
		@include thin-border();
	}
	.order-header-item {
		flex: 1;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	#order-item-left {
		justify-content: flex-start;
		margin-left: 10px;
	}
	#order-item-right {
		justify-content: flex-end;
	}
	.order-header-line {
		position: absolute;
		height: 1px;
		left: 10px;
		bottom: 0px;
		right: 10px;
		background-color: $lineColor;
	}
	.item-title {
		font-size: 14px;
		color: #4e545d;
	}
	.order-header-icon {
		width: 18px;
		height: 18px;
	}
	.order-header-title {
		margin-left: 8px;
	}
  .indicator {
		width: 7px;
		height: 12 px;
		margin-left: 10px;
		margin-right: 10px;
	}
	.order-subtitle {
		font-size: 14px;
		color: #7c7f88;
	}
	.order-wrapper {
		height: 88px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: stretch;
		background-color: #fff;
	}
	.order-item {
		flex: 1;
	}
  .list {
    background-color: #fff;
    padding: 12px;
    border-bottom: 1px solid #e8eaed;
    display: flex;
    align-content: center;
    align-items: center;
    div.list-checkbox {
      width: 20px;
      height: 20px;
      flex-basis: 20px;
      flex-shrink: 0;
      position: relative;
      margin-right: 5px;
      label {
        position: absolute;
        top: 0px;
        width: 20px;
        height: 20px;
        display: inline-block;
        background: url('../../../assets/image/change-icon/choice@2x.png')
          no-repeat;
        background-size: cover;
      }
      input {
        position: relative;
        width: 20px;
        margin: 0px;
        opacity: 0;
        background-color: #fff;
        &:checked + label {
          background: url('../../../assets/image/change-icon/multi_sel@2x.png')
            no-repeat;
          background-size: cover;
          width: 20px;
          height: 20px;
        }
        &:focus {
          outline-offset: 0px;
        }
      }
    }
    .list-item {
      display: flex;
      width: 100%;
      flex-direction: column;
      div.item {
        display: flex;
        width: 100%;
        div.ui-image {
          flex-shrink: 0;
          width: 90px;
          height: 90px;
          flex-basis: 90px;
          position: relative;
          img {
            width: 100%;
            height: 100%;
            border: 1px solid #e8eaed;
            border-radius: 3px;
          }
          span.promos {
            position: absolute;
            background: url('../../../assets/image/change-icon/label@2x.png')
              no-repeat;
            width: 36px;
            height: 19px;
            color: #ffffff;
            font-size: 10px;
            top: 0px;
            /* left: 0px; */
            background-size: cover;
            font-weight: 100;
            line-height: 19px;
            text-align: left;
            padding-left: 5px;
          }
          span.stock-info {
            position: absolute;
            height: 20px;
            background: rgba(243, 244, 245, 1);
            line-height: 20px;
            text-align: center;
            font-size: 14px;
            color: $primaryColor;
            width: 100%;
            bottom: 0px;
            left: 0px;
          }
        }
        div.list-info {
          margin-left: 10px;
          width: 100%;
          display: flex;
          flex-direction: column;
          align-content: center;
          justify-content: space-between;
          .product-header {
            display: flex;
            align-items: center;
            .promos-icon {
              width: 16px;
              height: 16px;
              margin-right: 4px;
            }
            .product-title {
              font-size: 14px;
              color: rgba(78, 84, 93, 1);
              padding: 0px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              &.disabled-list {
                color: #a4aab3;
              }
            }
          }
          h3 {
            font-size: 14px;
            color: rgba(78, 84, 93, 1);
            padding: 0px;
            margin: 0px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            &.disabled-list {
              color: #a4aab3;
            }
          }
          h3.property-info {
            font-size: 12px;
            color: #7c7f88;
          }
          div.info-price {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-content: flex-end;
            align-items: flex-end;
            p {
              font-size: 17px;
              color: $primaryColor;
              padding: 0px;
              margin: 0px;
              display: inline-block;
              &.disabled-list {
                color: #a4aab3;
              }
            }
          }
          div.ui-number {
            height: 24px;
            display: flex;
            border-radius: 3px 0px 0px 3px;
            input,
            div {
              height: 24px;
              text-align: center;
              color: #404245;
              display: inline-block;
              padding: 0px;
              margin: 0px;
              border: 0px;
              outline-offset: 0px;
            }
            .ui-common {
              line-height: 24px;
              width: 26px;
              height: 24px;
              border: 1px solid #c7c7cd;
              cursor: pointer;
            }
            .reduce {
              border-right: 0px;
            }
            .reduce-opacity {
              opacity: 0.4;
            }
            .add {
              border-left: 0px;
            }
            input[type='number'] {
              width: 26px;
              border: 1px solid #c7c7cd;
              border-radius: 0px;
              border-image-width: 0px;
              box-shadow: 0px;
              vertical-align: bottom;
              &:focus {
                outline: none;
              }
            }
          }
        }
      }
      p.list-promotion-info {
        margin-top: 12px;
        padding: 8px 0px;
        line-height: auto;
        font-size: 10px;
        color: #000;
        background: #f8f8f8;
        width: 100%;
        span {
          border: 1px solid $primaryColor;
          padding: 1px 4px;
          border-radius: 2px;
          font-size: 10px;
          color: $primaryColor;
          margin: 0px 10px;
          text-align: center;
        }
      }
    }
  }
}
.has-bottom {
  bottom: 94px;
}
</style>



// WEBPACK FOOTER //
// src/page/cart/child/CartList.vue